<template>
    <div class>
      <el-card shadow="never">
        <div slot="header">
          <span class="title">告警通知组信息</span>
      </div>
      <el-form :model="firstForm" :rules="firstRules" label-position="left" ref="firstForm" label-width="120px" style="width: 400px">
          <el-form-item label="告警通知组信息" prop="groupName">
              <el-input
              v-model="firstForm.groupName"
              placeholder="请输入告警通知组名称"
              ></el-input>
          </el-form-item>
          <el-form-item label="通知号码" prop="phoneList" style="width: 600px;">
              <el-input
              type="textarea"
              :rows="4"
              placeholder="请填写手机号码，如13888888888，13666666666"
              v-model="firstForm.phoneList"
              ></el-input>
          </el-form-item>
      </el-form>
      </el-card>
      <el-card shadow="never">
        <div slot="header">
          <span class="title">电站信息</span>
      </div>
      <el-form :model="secondForm" :rules="secondRules" label-position="left" ref="secondForm" label-width="120px" style="width: 400px;">
          <el-form-item label="选择电站" prop="stationIDs">
            <StreeNew v-model="secondForm.stationIDs" :data="datatree" style="width:400px;"></StreeNew>
          </el-form-item>
      </el-form>
      </el-card>
      <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </div>
</template>
<script>
  import { HOST, EV_HOST } from "@/utils/host";
  export default {
    name: "xiugaigaojingzu",
    components: {},
    data() {
      return {
          firstForm: {
            groupName: "",
            phoneList: "",
          },
          firstRules: {
            groupName:[
              { required: true, message: '请输入告警通知组名称', trigger: 'blur' }
            ],
            phoneList:[
              { required: true, message: '请填写手机号码，如13888888888，13666666666', trigger: 'blur' }
            ]
          },
          datatree: [],
          secondForm: {
            stationIDs: []
          },
          secondRules: {
            stationIDs:[{ required: true,message:''}]

          },
      };
    },
    computed: {
      headers() {
        return {
          token: window.localStorage.getItem("token")
        };
      },
      action() {
        return HOST + "/oss";
      }
    },
    methods: {

      cancel() {
          this.$router.go(-1);
      },
      save() {
        if(this.firstForm.phoneList && this.firstForm.groupName && this.secondForm.stationIDs[0]){
          let stationIDList = this.secondForm.stationIDs.join(",")
          let data = {
            id: this.id,
            groupName: this.firstForm.groupName,
            phoneList: this.firstForm.phoneList,
            stationIDs: stationIDList
          }
          this.$store.dispatch("form/handle", {
            url: "/alarm/alarmNoticeGroup/post",
            data: data,
            method: "post",
            callback: resp => {
              this.$router.go(-1)
            }
          });
        }else{
          this.$message({
            message: '必填项缺失，请添加。',
            type: 'warning'
          });
        }
      },

      getDataDetail() {
        let data = {
          id: this.id
        }
        this.$store.dispatch("form/handle", {
          url: "/alarm/alarmNoticeGroup/getEditData",
          data: data,
          method: "get",
          callback: resp => {
            console.log('tree',resp)
            this.firstForm.groupName = resp.groupName
            this.firstForm.phoneList = resp.phoneList
            this.secondForm.stationIDs = resp.stationIDs.split(",")
          }
        });
      },

      getTree(){
        this.$store.dispatch("form/handle", {
          url: "/alarm/alarmSet/connectorTree",
          method: "get",
          callback: resp => {
            console.log('tree',resp)
            this.datatree = resp;
          }
        });
      },
    },
    mounted() {
      this.getTree()
      this.getDataDetail()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {
      this.id = this.$route.query.data
    }, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };
  </script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
  }

  .iconfont {
    width: 50px;
    height: 50px;
    margin: auto;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  </style>



// WEBPACK FOOTER //
// src/views/alarmManagement/reviseGroup.vue